import { Box, styled, Typography } from "@mui/material";
import theme from "../../theme";

export const TemplateFormContainer = styled(Box)`
  margin-bottom: 1rem;

  .MuiGrid-container {
    margin-bottom: 1rem;
  }

  .MuiPaper-root {
    margin: 0 !important;
    box-shadow: none;
    background-color: ${theme.background};

    .MuiCardContent-root {
      padding: 0.5rem 0 0;

      .MuiGrid-container {
        .MuiGrid-item > fieldset {
          margin-bottom: 16px;
        }
      }
    }

    .MuiCardHeader-root {
      padding: 16px 0;
    }

    .MuiCardHeader-title {
      font-size: 1.3rem;
    }
  }

  .MuiGrid-root {
    margin-bottom: 0;
  }

  .MuiGrid2-root {
    margin-bottom: 0;
  }

  & > .MuiGrid-container {
    gap: 16px;
    margin-bottom: 16px;
  }

  .MuiGrid-direction-xs-row {
    & > .MuiGrid-direction-xs-column {
      & > .MuiGrid-direction-xs-row {
        margin-bottom: 16px;
      }
    }
  }

  & > .MuiGrid-container > div:empty {
    display: contents;
  }

  .MuiGrid-item > fieldset > legend:empty {
    height: 6px;
  }

  & input::-webkit-outer-spin-button,
  & input::-webkit-inner-spin-button {
    display: none;
  }

  & .MuiGrid-direction-xs-row {
    flex: 1;
  }
`;

export const EmptyFormErrorText = styled(Typography)`
  font-size: 14px;
  margin-bottom: 16px;
  font-weight: 500;
  color: ${theme.palette.error.main};
`;
